// import React, { useEffect, useState, useRef } from 'react';
// // import { bankModes } from './../config/reportName';
// import PropagateLoader from "react-spinners/PropagateLoader";
// import DataTable from 'react-data-table-component';
// import { isNumber } from './../Utils/Common';
// import { getGeoLocation, refId, isIfscCodeValid } from './../Utils/function';
// import { GET_BANK_SETTING_LIST, IFSC_CODE_VERIFY,BANK_DETAIL_UPDATE, GET_BANK_NAME_FROM_ACCOUNT_NUMBER_IN_BANK_SETTING, SAVE_BANK_SETTING_API, BANK_SETTING_CHANGE_STATUS, BANK_SETTING_DELETE, SET_DEFAULT_BANK_SETTING, GET_NAME, BANK_DETAIL } from './../Utils/appConstants';
// import { getRequest, postRequest, deleteRequestNewApi } from './../Utils/AppApi';
// import { useHistory } from "react-router-dom";
// import { ToastContainer, toast } from 'react-toastify';
// import { Divider, Tooltip } from 'antd';
// import { Popconfirm } from 'antd';
// const text = 'Are you sure to delete this data?';
// function BankSetting(props) {
//     const history = useHistory(); // eslint-disable-line react-hooks/exhaustive-deps
//     // const csvLink = useRef()
//     const [rowsPerPage, setRowsPerPage] = useState(10);
//     // const dateFormat = 'DD-MM-YYYY';
//     const [latitude, setLatitude] = useState("");
//     const [longitude, setLongitude] = useState("");
//     const [getDataField, setDataField] = useState({});
//     const [getDataError, setDataError] = useState({});
//     const [getData, setData] = useState([]);
//     const [isLoading, setLoading] = useState(false);
//     const [getTotalRecord, setTotalRecord] = useState(0);
//     const [page, setPage] = useState(1);
//     // const [isEdit, setIsEdit] = useState(false);
//     // const nameInput = useRef(null);
//     const accountNumberInput = useRef(null);
//     // const branchAddressInput = useRef(null);
//     // const bankNameInput = useRef(null);
//     const ifscCodeInput = useRef(null);
//     // const cityInput = useRef(null);
//     // const stateInput = useRef(null);
//     // const mobile = useFormInput('');
    
//     // Check if maximum account limit reached
//     const isMaxAccountsReached = () => {
//         return getData.docs && getData.docs.length >= 5;
//     }

//     const clearFormField = () => {
//         ifscCodeInput.current.value = "";
//         accountNumberInput.current.value = "";
//         // nameInput.current.value = "";
//         // branchAddressInput.current.value = "";
//         // bankNameInput.current.value = "";
//         // cityInput.current.value = "";
//         // stateInput.current.value = "";
//         setDataField({});
//         setDataError({});
//     }
//     const columns = [
//         {
//             name: '#',
//             selector: (row, index) => index + 1,
//             width: "50px"
//         },
//         {
//             name: 'Name',
//             selector: row => <><Tooltip title={row.name}>{row.name}</Tooltip></>,
//         }, {
//             name: 'Account Number',
//             selector: row => <><Tooltip title={row.accountNumber}>{row.accountNumber}</Tooltip></>,
//         }, {
//             name: 'Bank Name',
//             selector: row => <><Tooltip title={row.bankName}>{row.bankName}</Tooltip></>,
//         }, {
//             name: 'IFSC Code',
//             selector: row => <><Tooltip title={row.ifscCode}>{row.ifscCode}</Tooltip></>,
//         }, {
//             name: 'Branch Address',
//             selector: row => <><Tooltip title={row.branchAddress}>{row.branchAddress}</Tooltip></>,
//         }, {
//             name: 'City',
//             selector: row => row.city ? row.city : "-",
//         }, {
//             name: 'State',
//             selector: row => row.state ? row.state : "-",
//         },

//         {
//             name: 'Status',
//             cell: row => (
//                 <>
//                     {(row.isAdminApproved === 1) ?
//                         row.status ?
//                             <div className="text-danger pointer" onClick={(event) => handleChangeStatus(event, row._id, "false", row)} title='Deactive'>
//                                 <u><b>Deactive</b></u>
//                             </div>
//                             :
//                             <div className="text-success pointer" onClick={(event) => handleChangeStatus(event, row._id, "true", row)} title='Active'>
//                                 Active
//                             </div>
//                         :
//                         (row.status ?
//                             <span className="text-danger">Deactive</span>
//                             :
//                             <span className="text-success">Active</span>
//                         )
//                     }
//                 </>
//             ),
//         },

//         {
//             name: 'Action',
//             cell: row => <>{!row.isDefault ?
//                 <Popconfirm placement="left" title={text} onConfirm={(event) => handleDelete(event, row._id)} okText="Yes" cancelText="No"><div className='icon-border border border-danger text-danger pointer'><i className="fa fa-trash" aria-hidden="true"></i></div></Popconfirm>
//                 : <div className='icon-border border border-secondary text-secondary'><i className="fa fa-trash" aria-hidden="true"></i></div>
//             }</>,
//         },

//         {
//             name: 'Remark',
//             selector: row => (row.isAdminApproved === 1) ? "Approved" : "Rejected",
//         }] // eslint-disable-line react-hooks/exhaustive-deps


//     const handleDefaultBank = (id, rowData) => {
//         setLoading(true);
//         const payload = { "id": id };
//         postRequest(`${SET_DEFAULT_BANK_SETTING}`, payload, history).then((response) => {
//             if (response.success === true) {
//                 getDataReports();
//                 // Call handleBankSubmit when default bank is set
//                 handleBankSubmit(rowData);
//                 toast.success('Default bank set successfully');
//             } else {
//                 toast.error(response.message || 'Failed to set default bank');
//             }
//             setLoading(false);
//         }).catch(function (error) {
//             setLoading(false);
//             console.log(error);
//             toast.error('An error occurred while setting default bank');
//         });
//     }

//     const handleBankSubmit = (rowData) => {
//         if (!rowData) return;
        
//         const payload = {
//             name: rowData.name,
//             bankName: rowData.bankName,
//             accountNumber: rowData.accountNumber,
//             ifscCode: rowData.ifscCode,
//             branchAddress: rowData.branchAddress,
//             modes: rowData.modes ? rowData.modes.toString() : '',
//             remark: rowData.remark || '',
//         }
        
//         postRequest(BANK_DETAIL_UPDATE, payload, history).then((response) => {
//             if (response.success === true) {
//                 console.log('Bank detail submitted successfully');
//             } else {
//                 console.error('Failed to submit bank detail:', response.message);
//             }
//         }).catch(function (error) {
//             console.error('Error submitting bank detail:', error);
//         })
//     }

//     const objectToQueryString = (obj) => {
//         var str = [];
//         for (var p in obj)
//             if (obj.hasOwnProperty(p)) {
//                 str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
//             }
//         return str.join("&");
//     } // eslint-disable-line react-hooks/exhaustive-deps
//     const params = { page: page, limit: rowsPerPage };
//     const getDataReports = () => {
//         // if (startDate && endDate) {
//         // params.startDate = startDate ? startDate : "";
//         // params.endDate = endDate ? endDate : "";
//         // }
//         const queryString = objectToQueryString(params);
//         getRequest(`${GET_BANK_SETTING_LIST}?${queryString}`, history).then((response) => {
//             if (response.success === true) {
//                 setData(response.data);
//                 setTotalRecord(response.data.totalDocs);
//                 setPage(response.data.page);
//             } else {
//                 setData([]);
//                 setTotalRecord(0);
//                 setPage(1);
//                 toast.error(response.message || 'Failed to load bank data');
//             }
//         }).catch(function (error) {
//             console.log(error);
//             toast.error('An error occurred while loading bank data');
//             setData([]);
//             setTotalRecord(0);
//             setPage(1);
//         })
//     } // eslint-disable-line react-hooks/exhaustive-deps
//     const handlePageChange = page => {
//         setPage(page);
//     }; // eslint-disable-line react-hooks/exhaustive-deps
//     // const isIfscCodeValid = (ifsc_Code) => {
//     // let regex = new RegExp(/^[A-Z]{4}0[A-Z0-9]{6}$/);
//     // if (ifsc_Code === null) {
//     // return false;
//     // }
//     // if (regex.test(ifsc_Code) === true) {
//     // return true;
//     // }
//     // else {
//     // return false;
//     // }
//     // }
//     const onChangeIfscCode = (event) => {
//         const { name, value } = event.target;
//         setDataField({ ...getDataField, [name]: value });
//         if (isIfscCodeValid(value)) {
//             console.log("--- Valid", value);
//             setLoading(true);
//             const payload = { "ifsccode": value };
//             postRequest(`${IFSC_CODE_VERIFY}`, payload, history).then((response) => {
//                 if (response.success === true) {
//                     console.log("response.data-----------", response.data.data)
//                     let record = response.data.data;
//                     let data = {
//                         "ifscCode": record.ifsc,
//                         "address": record.address,
//                         "bankName": record.bank,
//                         "branchAddress": record.branch,
//                         "city": record.city,
//                         "state": record.state,
//                     }
//                     setDataField({ ...getDataField, ...data });
//                 } else {
//                     console.log("response.data-----------", response)
//                 }
//                 setLoading(false);
//             }).catch(function (error) {
//                 setLoading(false);
//                 console.log(error)
//             });
//         } else {
//             if (value.length === 11) {
//                 toast.error("Please enter valid ifsccode")
//                 let data = {
//                     "address": '',
//                     "bankName": '',
//                     "branchAddress": '',
//                     "city": '',
//                     "state": '',
//                 }
//                 setDataField({ ...getDataField, ...data });
//             }
//         }
//     }

//     const getBankNameFromAccountNumber = () => {
//         if (getDataField.accountNumber && getDataField.ifscCode) {
//             // console.log("--- Valid -- 1", getDataField)
//             setLoading(true);
//             // Inline fallback for refId if not available in utils (remove once fixed in utils)
//             const generateRefId = (length) => {
//                 const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
//                 let result = '';
//                 for (let i = 0; i < length; i++) {
//                     result += chars.charAt(Math.floor(Math.random() * chars.length));
//                 }
//                 return result;
//             };
//             const payload = {
//                 "ifsccode": getDataField.ifscCode,
//                 "accountNumber": getDataField.accountNumber,
//                 "externalRef": generateRefId(13), // Use refId(13) once fixed in utils
//                 "consent": "Y",
//                 "pennyDrop": "AUTO",
//                 "latitude": latitude,
//                 "longitude": longitude
//             };
//             postRequest(`${GET_BANK_NAME_FROM_ACCOUNT_NUMBER_IN_BANK_SETTING}`, payload, history).then((response) => {
//                 if (response.success === true) {
//                     // console.log("response.data-----------", response.data.data)
//                     let record = response.data.data;
//                     let data = { "name": record.nameAtBank }
//                     setDataField({ ...getDataField, ...data });
//                 } else {
//                     // console.log("response.data-----------", response)
//                     toast.error(response.message);
//                 }
//                 setLoading(false);
//             }).catch(function (error) {
//                 setLoading(false);
//                 console.log(error)
//             });
//         } else {
//             toast.error("Please enter valid account number")
//             let data = { "name": '' }
//             setDataField({ ...getDataField, ...data });
//         }
//     }
//     const onChangeValue = (event) => {
//         const { name, value } = event.target;
//         setDataField({ ...getDataField, [name]: value });
//     } // eslint-disable-line react-hooks/exhaustive-deps
//     const FormValidate = () => {
//         let formValid = true;
//         let formObject = {};
//         setDataError({})
//         if (getDataField && Object.keys(getDataField).length === 0) {
//             formValid = false;
//         }
//         let array = ["ifscCode", "accountNumber", "name", "bankName", "branchAddress", "city", "state"];
//         array.forEach(element => {
//             if (getDataField[element] === "" || typeof getDataField[element] === "undefined") {
//                 formObject[element] = true;
//                 formValid = false;
//             }
//         });
//         setDataError(formObject);
//         return formValid;
//     } // eslint-disable-line react-hooks/exhaustive-deps


//     const handleChangeStatus = async (event, id, statusStr, rowData) => {
//         setLoading(true);
//         try {
//             if (statusStr === "true") {
//                 // Activate and set as default bank
//                 // First set as default bank
//                 const defaultResponse = await postRequest(`${SET_DEFAULT_BANK_SETTING}`, { "id": id }, history);
//                 if (defaultResponse.success === true) {
//                     // Then activate the bank
//                     const payload = { status: statusStr };
//                     const response = await postRequest(`${BANK_SETTING_CHANGE_STATUS}/${id}`, payload, history);
//                     if (response.success === true) {
//                         getDataReports();
//                         // Call handleBankSubmit when bank is activated and set as default
//                         handleBankSubmit(rowData);
//                         toast.success('Bank activated and set as default successfully');
//                     } else {
//                         toast.error(response.message || 'Failed to activate bank');
//                     }
//                 } else {
//                     toast.error(defaultResponse.message || 'Failed to set default bank');
//                 }
//             } else {
//                 // Deactivate the bank
//                 const payload = { status: statusStr };
//                 const response = await postRequest(`${BANK_SETTING_CHANGE_STATUS}/${id}`, payload, history);
//                 if (response.success === true) {
//                     getDataReports();
//                     toast.success('Bank deactivated successfully');
//                 } else {
//                     toast.error(response.message || 'Failed to deactivate bank');
//                 }
//             }
//         } catch (error) {
//             console.log('Change status error:', error);
//             toast.error(`An error occurred while ${statusStr === "true" ? 'activating' : 'deactivating'} bank`);
//         } finally {
//             setLoading(false);
//         }
//     } // eslint-disable-line react-hooks/exhaustive-deps

//     const handleDelete = (event, id) => {
//         let payload = { removed: false };
//         deleteRequestNewApi(`${BANK_SETTING_DELETE}/${id}`, payload, history).then((response) => {
//             // console.log("response -------", response)
//             if (response.success === true) {
//                 getDataReports();
//                 toast.success(response.message);
//             } else {
//                 toast.error(response.message || 'Failed to delete bank');
//             }
//         }).catch(function (error) {
//             console.log(error);
//             toast.error('An error occurred while deleting bank');
//         })
//     } // eslint-disable-line react-hooks/exhaustive-deps
//     const handleSubmit = () => {
//         // Check if maximum accounts reached
//         if (isMaxAccountsReached()) {
//             toast.error('Maximum limit of 5 bank accounts reached. Please delete an existing account to add a new one.');
//             return;
//         }

//         if (FormValidate()) {
//             setLoading(true);
//             const payload = {
//                 name: getDataField.name,
//                 bankName: getDataField.bankName,
//                 accountNumber: getDataField.accountNumber,
//                 ifscCode: getDataField.ifscCode,
//                 branchAddress: getDataField.branchAddress,
//                 address: getDataField.address,
//                 city: getDataField.city,
//                 state: getDataField.state,
//             }
//             postRequest(SAVE_BANK_SETTING_API, payload, history).then((response) => {
//                 if (response.success === true) {
//                     setDataField({});
//                     setDataError({});
//                     clearFormField();
//                     getDataReports();
//                     toast.success(response.message || 'Bank saved successfully');
//                 } else {
//                     toast.error(response.message || 'Failed to save bank');
//                 }
//                 setLoading(false);
//             }).catch(function (error) {
//                 setLoading(false);
//                 // console.log(error)
//                 // setLoading(false);
//             })
//         }
//     } // eslint-disable-line react-hooks/exhaustive-deps
//     const fetchLocation = async () => {
//         try {
//             let data = await getGeoLocation();
//             setLatitude(data.latitude);
//             setLongitude(data.longitude);
//         } catch (error) {
//             console.error("Error fetching location:", error);
//         }
//     }
//     useEffect(() => {
//         getDataReports();
//         fetchLocation();
//     }, [page, rowsPerPage]) // eslint-disable-line react-hooks/exhaustive-deps
//     if (isLoading) {
//         return <div className="content text-center" style={{ margin: "250px 0" }}>
//             <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
//         </div>
//     }
//     return (
//         <div>
//             <div className="content-wrapper pt-2">
//                 <div className="content-header my-0 py-0">
//                     <div className="container-fluid">
//                         <div className="row mb-0 align-items-center">
//                             <div className="col-sm-6">
//                                 <h1 className='page-title text-blue font-merriweather'>Bank <span className='text-red'>Setting</span></h1>
//                             </div>
//                             <div className="col-sm-6 text-right">
//                                 <div className="account-counter">
//                                     <small className="text-muted">
//                                         {getData.docs ? getData.docs.length : 0}/5 accounts added
//                                     </small>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="content">
//                     <div className="container-fluid pt-2 pb-5">
//                         <div className="row">
//                             <div className="col-md-12">
//                                 <div className='card rounded-0'>
//                                     <div className='card-body'>
//                                         {isMaxAccountsReached() && (
//                                             <div className="alert alert-warning mb-3">
//                                                 <i className="fa fa-exclamation-triangle mr-2"></i>
//                                                 Maximum limit of 5 bank accounts reached. Please delete an existing account to add a new one.
//                                             </div>
//                                         )}
//                                         <div className='col-md-12'>
//                                             <div className='row'>
//                                                 <div className='col-sm-6 col-md-4 col-lg-3'>
//                                                     <div className="form-group">
//                                                         <label>IFSC Code</label>
//                                                         <input 
//                                                             type="text" 
//                                                             className={`form-control normal-light ${getDataError && getDataError.ifscCode ? "is-invalid" : ""}`} 
//                                                             name="ifscCode" 
//                                                             ref={ifscCodeInput} 
//                                                             maxLength={11} 
//                                                             onChange={(e) => onChangeIfscCode(e)} 
//                                                             placeholder="IFSC Code*" 
//                                                             value={getDataField && getDataField.ifscCode} 
//                                                             disabled={isMaxAccountsReached()}
//                                                         />
//                                                         {getDataError && getDataError.ifscCode && <span className="error text-danger">The field is required</span>}
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-sm-6 col-md-4 col-lg-3'>
//                                                     <div className="form-group">
//                                                         <label>Account Number</label>
//                                                         <div className="position-relative">
//                                                             <input 
//                                                                 type="text" 
//                                                                 className={`form-control normal-light ${getDataError && getDataError.accountNumber ? "is-invalid" : ""}`} 
//                                                                 name="accountNumber" 
//                                                                 ref={accountNumberInput} 
//                                                                 maxLength={20} 
//                                                                 onKeyDown={isNumber} 
//                                                                 onChange={(e) => onChangeValue(e)} 
//                                                                 placeholder="Account Number*" 
//                                                                 value={getDataField && getDataField.accountNumber} 
//                                                                 disabled={isMaxAccountsReached()}
//                                                             />
//                                                             <div className="inputgrouptext cursor-pointer text-success" onClick={getBankNameFromAccountNumber}>{GET_NAME}</div>
//                                                         </div>
//                                                         {getDataError && getDataError.accountNumber && <span className="error text-danger">The field is required</span>}
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-sm-6 col-md-4 col-lg-3'>
//                                                     <div className="form-group">
//                                                         <label>Name</label>
//                                                         <input 
//                                                             type="text" 
//                                                             className={`form-control normal-light ${getDataError && getDataError.name ? "is-invalid" : ""}`} 
//                                                             placeholder="Name" 
//                                                             value={getDataField && getDataField.name} 
//                                                             readOnly 
//                                                             disabled={isMaxAccountsReached()}
//                                                         />
//                                                         {getDataError && getDataError.name && <span className="error text-danger">The field is required</span>}
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-sm-6 col-md-4 col-lg-3'>
//                                                     <div className="form-group">
//                                                         <label>Bank Name</label>
//                                                         <input 
//                                                             type="text" 
//                                                             className={`form-control normal-light ${getDataError && getDataError.bankName ? "is-invalid" : ""}`} 
//                                                             placeholder="Bank Name*" 
//                                                             value={getDataField && getDataField.bankName} 
//                                                             readOnly 
//                                                             disabled={isMaxAccountsReached()}
//                                                         />
//                                                         {getDataError && getDataError.bankName && <span className="error text-danger">The field is required</span>}
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-sm-6 col-md-4 col-lg-3'>
//                                                     <div className="form-group">
//                                                         <label>Branch Address</label>
//                                                         <input 
//                                                             type="text" 
//                                                             className={`form-control normal-light${getDataError && getDataError.branchAddress ? "is-invalid" : ""}`} 
//                                                             placeholder="Branch Address*" 
//                                                             value={getDataField && getDataField.branchAddress} 
//                                                             readOnly 
//                                                             disabled={isMaxAccountsReached()}
//                                                         />
//                                                         {getDataError && getDataError.branchAddress && <span className="error text-danger">The field is required</span>}
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-sm-6 col-md-4 col-lg-3'>
//                                                     <div className="form-group">
//                                                         <label>City</label>
//                                                         <input 
//                                                             type="text" 
//                                                             className={`form-control normal-light`} 
//                                                             placeholder="City" 
//                                                             value={getDataField && getDataField.city} 
//                                                             readOnly 
//                                                             disabled={isMaxAccountsReached()}
//                                                         />
//                                                         {getDataError && getDataError.city && <span className="error text-danger">The field is required</span>}
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-sm-6 col-md-4 col-lg-3'>
//                                                     <div className="form-group">
//                                                         <label>State</label>
//                                                         <input 
//                                                             type="text" 
//                                                             className={`form-control normal-light `} 
//                                                             placeholder="State" 
//                                                             value={getDataField && getDataField.state} 
//                                                             readOnly 
//                                                             disabled={isMaxAccountsReached()}
//                                                         />
//                                                         {getDataError && getDataError.state && <span className="error text-danger">The field is required</span>}
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-sm-6 col-md-4 col-lg-2'>
//                                                     <label className='d-none d-lg-block'>&nbsp;</label>
//                                                     <div className="form-group text-lg-center">
//                                                         <button 
//                                                             type="submit" 
//                                                             className="btn btn-primary rounded-pill pl-4 pr-4" 
//                                                             onClick={() => handleSubmit()}
//                                                             disabled={isMaxAccountsReached()}
//                                                         >
//                                                             Add Account
//                                                         </button>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <Divider />
//                                     <div className='card-body'>
//                                         <div className="content-header my-0 px-0">
//                                             <h1 className='page-title text-blue font-merriweather mb-3'>Registered <span className='text-red'>Bank Account</span></h1>
//                                         </div>
//                                         <div className='history-table'>
//                                             <div className="container-fluid pb-5">
//                                                 <div className="col-md-12">
//                                                     <DataTable
//                                                         title={""}
//                                                         columns={columns}
//                                                         data={getData.docs}
//                                                         highlightOnHover
//                                                         pagination
//                                                         paginationServer
//                                                         paginationTotalRows={getTotalRecord}
//                                                         onChangeRowsPerPage={(newRowsPerPage) => {
//                                                             setRowsPerPage(newRowsPerPage);
//                                                             setPage(1);
//                                                         }}
//                                                         onChangePage={handlePageChange}
//                                                     />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 <ToastContainer position="top-center" autoClose={5000} limit={2} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="colored" />
//             </div>
//         </div>
//     )
// }
// export default BankSetting;

import React, { useEffect, useState, useRef } from 'react';
// import { bankModes } from './../config/reportName';
import PropagateLoader from "react-spinners/PropagateLoader";
import DataTable from 'react-data-table-component';
import { isNumber } from './../Utils/Common';
import { getGeoLocation, refId, isIfscCodeValid } from './../Utils/function';
import { GET_BANK_SETTING_LIST, IFSC_CODE_VERIFY,BANK_DETAIL_UPDATE, GET_CUSTOMER_BANK_NAME_FROM_ACCOUNT_NUMBER, SAVE_BANK_SETTING_API, BANK_SETTING_CHANGE_STATUS, BANK_SETTING_DELETE, SET_DEFAULT_BANK_SETTING, GET_NAME, BANK_DETAIL } from './../Utils/appConstants';
import { getRequest, postRequest, deleteRequestNewApi } from './../Utils/AppApi';
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import { Divider, Tooltip } from 'antd';
import { Popconfirm } from 'antd';

// ---- Shared bank verification (single-file module) ----
import {
  showBankVerifyPicker,
  useBankVerification,
} from './../Utils/bankVerification';

const text = 'Are you sure to delete this data?';

// Key used to identify this screen's in-flight verification
const VERIFY_KEY = 'bank_setting';

function BankSetting(props) {
    const history = useHistory(); // eslint-disable-line react-hooks/exhaustive-deps
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [getDataField, setDataField] = useState({});
    const [getDataError, setDataError] = useState({});
    const [getData, setData] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [getTotalRecord, setTotalRecord] = useState(0);
    const [page, setPage] = useState(1);
    const accountNumberInput = useRef(null);
    const ifscCodeInput = useRef(null);

    // ---- Bank verification (shared hook) ----
    const { verifyingKey, verify } = useBankVerification();

    // Check if maximum account limit reached
    const isMaxAccountsReached = () => {
        return getData.docs && getData.docs.length >= 5;
    }

    const clearFormField = () => {
        ifscCodeInput.current.value = "";
        accountNumberInput.current.value = "";
        setDataField({});
        setDataError({});
    }

    const columns = [
        {
            name: '#',
            selector: (row, index) => index + 1,
            width: "50px"
        },
        {
            name: 'Name',
            selector: row => <><Tooltip title={row.name}>{row.name}</Tooltip></>,
        }, {
            name: 'Account Number',
            selector: row => <><Tooltip title={row.accountNumber}>{row.accountNumber}</Tooltip></>,
        }, {
            name: 'Bank Name',
            selector: row => <><Tooltip title={row.bankName}>{row.bankName}</Tooltip></>,
        }, {
            name: 'IFSC Code',
            selector: row => <><Tooltip title={row.ifscCode}>{row.ifscCode}</Tooltip></>,
        }, {
            name: 'Branch Address',
            selector: row => <><Tooltip title={row.branchAddress}>{row.branchAddress}</Tooltip></>,
        }, {
            name: 'City',
            selector: row => row.city ? row.city : "-",
        }, {
            name: 'State',
            selector: row => row.state ? row.state : "-",
        },
        {
            name: 'Status',
            cell: row => (
                <>
                    {(row.isAdminApproved === 1) ?
                        row.status ?
                            <div className="text-danger pointer" onClick={(event) => handleChangeStatus(event, row._id, "false", row)} title='Deactive'>
                                <u><b>Deactive</b></u>
                            </div>
                            :
                            <div className="text-success pointer" onClick={(event) => handleChangeStatus(event, row._id, "true", row)} title='Active'>
                                Active
                            </div>
                        :
                        (row.status ?
                            <span className="text-danger">Deactive</span>
                            :
                            <span className="text-success">Active</span>
                        )
                    }
                </>
            ),
        },
        {
            name: 'Action',
            cell: row => <>{!row.isDefault ?
                <Popconfirm placement="left" title={text} onConfirm={(event) => handleDelete(event, row._id)} okText="Yes" cancelText="No"><div className='icon-border border border-danger text-danger pointer'><i className="fa fa-trash" aria-hidden="true"></i></div></Popconfirm>
                : <div className='icon-border border border-secondary text-secondary'><i className="fa fa-trash" aria-hidden="true"></i></div>
            }</>,
        },
        {
            name: 'Remark',
            selector: row => (row.isAdminApproved === 1) ? "Approved" : "Rejected",
        }] // eslint-disable-line react-hooks/exhaustive-deps


    const handleDefaultBank = (id, rowData) => {
        setLoading(true);
        const payload = { "id": id };
        postRequest(`${SET_DEFAULT_BANK_SETTING}`, payload, history).then((response) => {
            if (response.success === true) {
                getDataReports();
                handleBankSubmit(rowData);
                toast.success('Default bank set successfully');
            } else {
                toast.error(response.message || 'Failed to set default bank');
            }
            setLoading(false);
        }).catch(function (error) {
            setLoading(false);
            console.log(error);
            toast.error('An error occurred while setting default bank');
        });
    }

    const handleBankSubmit = (rowData) => {
        if (!rowData) return;

        const payload = {
            name: rowData.name,
            bankName: rowData.bankName,
            accountNumber: rowData.accountNumber,
            ifscCode: rowData.ifscCode,
            branchAddress: rowData.branchAddress,
            modes: rowData.modes ? rowData.modes.toString() : '',
            remark: rowData.remark || '',
        }

        postRequest(BANK_DETAIL_UPDATE, payload, history).then((response) => {
            if (response.success === true) {
                console.log('Bank detail submitted successfully');
            } else {
                console.error('Failed to submit bank detail:', response.message);
            }
        }).catch(function (error) {
            console.error('Error submitting bank detail:', error);
        })
    }

    const objectToQueryString = (obj) => {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    } // eslint-disable-line react-hooks/exhaustive-deps

    const params = { page: page, limit: rowsPerPage };

    const getDataReports = () => {
        const queryString = objectToQueryString(params);
        getRequest(`${GET_BANK_SETTING_LIST}?${queryString}`, history).then((response) => {
            if (response.success === true) {
                setData(response.data);
                setTotalRecord(response.data.totalDocs);
                setPage(response.data.page);
            } else {
                setData([]);
                setTotalRecord(0);
                setPage(1);
                toast.error(response.message || 'Failed to load bank data');
            }
        }).catch(function (error) {
            console.log(error);
            toast.error('An error occurred while loading bank data');
            setData([]);
            setTotalRecord(0);
            setPage(1);
        })
    } // eslint-disable-line react-hooks/exhaustive-deps

    const handlePageChange = page => {
        setPage(page);
    }; // eslint-disable-line react-hooks/exhaustive-deps

    const onChangeIfscCode = (event) => {
        const { name, value } = event.target;
        setDataField({ ...getDataField, [name]: value });
        if (isIfscCodeValid(value)) {
            setLoading(true);
            const payload = { "ifsccode": value };
            postRequest(`${IFSC_CODE_VERIFY}`, payload, history).then((response) => {
                if (response.success === true) {
                    let record = response.data.data;
                    let data = {
                        "ifscCode": record.ifsc,
                        "address": record.address,
                        "bankName": record.bank,
                        "branchAddress": record.branch,
                        "city": record.city,
                        "state": record.state,
                    }
                    setDataField({ ...getDataField, ...data });
                } else {
                    console.log("response.data-----------", response)
                }
                setLoading(false);
            }).catch(function (error) {
                setLoading(false);
                console.log(error)
            });
        } else {
            if (value.length === 11) {
                toast.error("Please enter valid ifsccode")
                let data = {
                    "address": '',
                    "bankName": '',
                    "branchAddress": '',
                    "city": '',
                    "state": '',
                }
                setDataField({ ...getDataField, ...data });
            }
        }
    }

    // ============================================================
    // Bank verification — Bank 1 / Bank 2 picker (shared hook)
    // ============================================================
    const getBankNameFromAccountNumber = () => {
        const accountNumber = (getDataField.accountNumber || '').trim();
        const ifscCode = (getDataField.ifscCode || '').trim();

        if (!accountNumber || !ifscCode) {
            toast.error("Please enter account number and IFSC first");
            setDataField({ ...getDataField, name: '' });
            return;
        }
        if (accountNumber.length < 9 || accountNumber.length > 20) {
            toast.error("Please enter a valid account number");
            return;
        }

        // Bank 1 / Bank 2 picker — same UX as DMT bene screens
        showBankVerifyPicker({
            title: 'Verify Bank Account',
            subtitle: 'Choose a verification method',
            onBank1: () => runVerify(false),
            onBank2: () => runVerify(true),
        });
    };

    const runVerify = (recheck) => {
        verify({
            key: VERIFY_KEY,
            accountNumber: (getDataField.accountNumber || '').trim(),
            ifscCode: (getDataField.ifscCode || '').trim(),
            recheck: !!recheck,
            endpoint: GET_CUSTOMER_BANK_NAME_FROM_ACCOUNT_NUMBER,
            latitude,
            longitude,
            history,
            onSuccess: (result) => {
                setDataField((prev) => ({ ...prev, name: result.nameAtBank }));
            },
        });
    };

    const onChangeValue = (event) => {
        const { name, value } = event.target;
        setDataField({ ...getDataField, [name]: value });
    } // eslint-disable-line react-hooks/exhaustive-deps

    const FormValidate = () => {
        let formValid = true;
        let formObject = {};
        setDataError({})
        if (getDataField && Object.keys(getDataField).length === 0) {
            formValid = false;
        }
        let array = ["ifscCode", "accountNumber", "name", "bankName", "branchAddress", "city", "state"];
        array.forEach(element => {
            if (getDataField[element] === "" || typeof getDataField[element] === "undefined") {
                formObject[element] = true;
                formValid = false;
            }
        });
        setDataError(formObject);
        return formValid;
    } // eslint-disable-line react-hooks/exhaustive-deps


    const handleChangeStatus = async (event, id, statusStr, rowData) => {
        setLoading(true);
        try {
            if (statusStr === "true") {
                const defaultResponse = await postRequest(`${SET_DEFAULT_BANK_SETTING}`, { "id": id }, history);
                if (defaultResponse.success === true) {
                    const payload = { status: statusStr };
                    const response = await postRequest(`${BANK_SETTING_CHANGE_STATUS}/${id}`, payload, history);
                    if (response.success === true) {
                        getDataReports();
                        handleBankSubmit(rowData);
                        toast.success('Bank activated and set as default successfully');
                    } else {
                        toast.error(response.message || 'Failed to activate bank');
                    }
                } else {
                    toast.error(defaultResponse.message || 'Failed to set default bank');
                }
            } else {
                const payload = { status: statusStr };
                const response = await postRequest(`${BANK_SETTING_CHANGE_STATUS}/${id}`, payload, history);
                if (response.success === true) {
                    getDataReports();
                    toast.success('Bank deactivated successfully');
                } else {
                    toast.error(response.message || 'Failed to deactivate bank');
                }
            }
        } catch (error) {
            console.log('Change status error:', error);
            toast.error(`An error occurred while ${statusStr === "true" ? 'activating' : 'deactivating'} bank`);
        } finally {
            setLoading(false);
        }
    } // eslint-disable-line react-hooks/exhaustive-deps

    const handleDelete = (event, id) => {
        let payload = { removed: false };
        deleteRequestNewApi(`${BANK_SETTING_DELETE}/${id}`, payload, history).then((response) => {
            if (response.success === true) {
                getDataReports();
                toast.success(response.message);
            } else {
                toast.error(response.message || 'Failed to delete bank');
            }
        }).catch(function (error) {
            console.log(error);
            toast.error('An error occurred while deleting bank');
        })
    } // eslint-disable-line react-hooks/exhaustive-deps

    const handleSubmit = () => {
        if (isMaxAccountsReached()) {
            toast.error('Maximum limit of 5 bank accounts reached. Please delete an existing account to add a new one.');
            return;
        }

        if (FormValidate()) {
            setLoading(true);
            const payload = {
                name: getDataField.name,
                bankName: getDataField.bankName,
                accountNumber: getDataField.accountNumber,
                ifscCode: getDataField.ifscCode,
                branchAddress: getDataField.branchAddress,
                address: getDataField.address,
                city: getDataField.city,
                state: getDataField.state,
            }
            postRequest(SAVE_BANK_SETTING_API, payload, history).then((response) => {
                if (response.success === true) {
                    setDataField({});
                    setDataError({});
                    clearFormField();
                    getDataReports();
                    toast.success(response.message || 'Bank saved successfully');
                } else {
                    toast.error(response.message || 'Failed to save bank');
                }
                setLoading(false);
            }).catch(function (error) {
                setLoading(false);
            })
        }
    } // eslint-disable-line react-hooks/exhaustive-deps

    const fetchLocation = async () => {
        try {
            let data = await getGeoLocation();
            setLatitude(data.latitude);
            setLongitude(data.longitude);
        } catch (error) {
            console.error("Error fetching location:", error);
        }
    }

    useEffect(() => {
        getDataReports();
        fetchLocation();
    }, [page, rowsPerPage]) // eslint-disable-line react-hooks/exhaustive-deps

    if (isLoading) {
        return <div className="content text-center" style={{ margin: "250px 0" }}>
            <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
        </div>
    }

    const isVerifying = verifyingKey === VERIFY_KEY;

    return (
        <div>
            <div className="content-wrapper pt-2">
                <div className="content-header my-0 py-0">
                    <div className="container-fluid">
                        <div className="row mb-0 align-items-center">
                            <div className="col-sm-6">
                                <h1 className='page-title text-blue font-merriweather'>Bank <span className='text-red'>Setting</span></h1>
                            </div>
                            <div className="col-sm-6 text-right">
                                <div className="account-counter">
                                    <small className="text-muted">
                                        {getData.docs ? getData.docs.length : 0}/5 accounts added
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="container-fluid pt-2 pb-5">
                        <div className="row">
                            <div className="col-md-12">
                                <div className='card rounded-0'>
                                    <div className='card-body'>
                                        {isMaxAccountsReached() && (
                                            <div className="alert alert-warning mb-3">
                                                <i className="fa fa-exclamation-triangle mr-2"></i>
                                                Maximum limit of 5 bank accounts reached. Please delete an existing account to add a new one.
                                            </div>
                                        )}
                                        <div className='col-md-12'>
                                            <div className='row'>
                                                <div className='col-sm-6 col-md-4 col-lg-3'>
                                                    <div className="form-group">
                                                        <label>IFSC Code</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control normal-light ${getDataError && getDataError.ifscCode ? "is-invalid" : ""}`}
                                                            name="ifscCode"
                                                            ref={ifscCodeInput}
                                                            maxLength={11}
                                                            onChange={(e) => onChangeIfscCode(e)}
                                                            placeholder="IFSC Code*"
                                                            value={getDataField && getDataField.ifscCode}
                                                            disabled={isMaxAccountsReached()}
                                                        />
                                                        {getDataError && getDataError.ifscCode && <span className="error text-danger">The field is required</span>}
                                                    </div>
                                                </div>
                                                <div className='col-sm-6 col-md-4 col-lg-3'>
                                                    <div className="form-group">
                                                        <label>Account Number</label>
                                                        <div className="position-relative">
                                                            <input
                                                                type="text"
                                                                className={`form-control normal-light ${getDataError && getDataError.accountNumber ? "is-invalid" : ""}`}
                                                                name="accountNumber"
                                                                ref={accountNumberInput}
                                                                maxLength={20}
                                                                onKeyDown={isNumber}
                                                                onChange={(e) => onChangeValue(e)}
                                                                placeholder="Account Number*"
                                                                value={getDataField && getDataField.accountNumber}
                                                                disabled={isMaxAccountsReached()}
                                                            />
                                                            {/* ---- Get Name → Bank 1 / Bank 2 picker ---- */}
                                                            <div
                                                                className="inputgrouptext cursor-pointer text-success"
                                                                onClick={isVerifying ? undefined : getBankNameFromAccountNumber}
                                                                style={isVerifying
                                                                    ? { pointerEvents: 'none', opacity: 0.6 }
                                                                    : {}}
                                                            >
                                                                {isVerifying ? 'Verifying...' : GET_NAME}
                                                            </div>
                                                        </div>
                                                        {getDataError && getDataError.accountNumber && <span className="error text-danger">The field is required</span>}
                                                    </div>
                                                </div>
                                                <div className='col-sm-6 col-md-4 col-lg-3'>
                                                    <div className="form-group">
                                                        <label>Name</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control normal-light ${getDataError && getDataError.name ? "is-invalid" : ""}`}
                                                            placeholder="Name"
                                                            value={getDataField && getDataField.name}
                                                            readOnly
                                                            disabled={isMaxAccountsReached()}
                                                        />
                                                        {getDataError && getDataError.name && <span className="error text-danger">The field is required</span>}
                                                    </div>
                                                </div>
                                                <div className='col-sm-6 col-md-4 col-lg-3'>
                                                    <div className="form-group">
                                                        <label>Bank Name</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control normal-light ${getDataError && getDataError.bankName ? "is-invalid" : ""}`}
                                                            placeholder="Bank Name*"
                                                            value={getDataField && getDataField.bankName}
                                                            readOnly
                                                            disabled={isMaxAccountsReached()}
                                                        />
                                                        {getDataError && getDataError.bankName && <span className="error text-danger">The field is required</span>}
                                                    </div>
                                                </div>
                                                <div className='col-sm-6 col-md-4 col-lg-3'>
                                                    <div className="form-group">
                                                        <label>Branch Address</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control normal-light${getDataError && getDataError.branchAddress ? "is-invalid" : ""}`}
                                                            placeholder="Branch Address*"
                                                            value={getDataField && getDataField.branchAddress}
                                                            readOnly
                                                            disabled={isMaxAccountsReached()}
                                                        />
                                                        {getDataError && getDataError.branchAddress && <span className="error text-danger">The field is required</span>}
                                                    </div>
                                                </div>
                                                <div className='col-sm-6 col-md-4 col-lg-3'>
                                                    <div className="form-group">
                                                        <label>City</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control normal-light`}
                                                            placeholder="City"
                                                            value={getDataField && getDataField.city}
                                                            readOnly
                                                            disabled={isMaxAccountsReached()}
                                                        />
                                                        {getDataError && getDataError.city && <span className="error text-danger">The field is required</span>}
                                                    </div>
                                                </div>
                                                <div className='col-sm-6 col-md-4 col-lg-3'>
                                                    <div className="form-group">
                                                        <label>State</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control normal-light `}
                                                            placeholder="State"
                                                            value={getDataField && getDataField.state}
                                                            readOnly
                                                            disabled={isMaxAccountsReached()}
                                                        />
                                                        {getDataError && getDataError.state && <span className="error text-danger">The field is required</span>}
                                                    </div>
                                                </div>
                                                <div className='col-sm-6 col-md-4 col-lg-2'>
                                                    <label className='d-none d-lg-block'>&nbsp;</label>
                                                    <div className="form-group text-lg-center">
                                                        <button
                                                            type="submit"
                                                            className="btn btn-primary rounded-pill pl-4 pr-4"
                                                            onClick={() => handleSubmit()}
                                                            disabled={isMaxAccountsReached()}
                                                        >
                                                            Add Account
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Divider />
                                    <div className='card-body'>
                                        <div className="content-header my-0 px-0">
                                            <h1 className='page-title text-blue font-merriweather mb-3'>Registered <span className='text-red'>Bank Account</span></h1>
                                        </div>
                                        <div className='history-table'>
                                            <div className="container-fluid pb-5">
                                                <div className="col-md-12">
                                                    <DataTable
                                                        title={""}
                                                        columns={columns}
                                                        data={getData.docs}
                                                        highlightOnHover
                                                        pagination
                                                        paginationServer
                                                        paginationTotalRows={getTotalRecord}
                                                        onChangeRowsPerPage={(newRowsPerPage) => {
                                                            setRowsPerPage(newRowsPerPage);
                                                            setPage(1);
                                                        }}
                                                        onChangePage={handlePageChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer position="top-center" autoClose={5000} limit={2} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="colored" />
            </div>
        </div>
    )
}
export default BankSetting;